import { Customer } from "../types/customers";

export const RM_CLIENT = "rm-client";
export const NON_RM_CLIENT = "non-rm-client";

export const RM_CLIENTS = [
  Customer.KOMAX,
  Customer.SCHIEBEL,
  Customer.CAE,
  Customer.CEOTRONICS,
  Customer.AIRBUSDS,
  Customer.MAQUETGMBH,
  Customer.IAV,
  Customer.HERRMANNULTRASCHALL,
  Customer.LRE,
  Customer.LUTRON,
  Customer.KVB,
  Customer.RUAGCH,
  Customer.EMZ,
  Customer.TRIAL1,
  Customer.TRIAL2,
  Customer.TRIAL3,
  Customer.TRIAL4,
  Customer.TTI,
  Customer.MTU,
  Customer.NS,
  Customer.MRCE,
  Customer.DEMO,
  Customer.DEMOZ2DATA,
  Customer.ATLAS,
  Customer.KNDS,
  Customer.ROSEN,
  Customer.TAE,
  Customer.KARLSTORZ,
  Customer.XLIVE,
  Customer.STADLER,
  Customer.AUTOFLUG,
  Customer.SEW,
  Customer.PLASTICOMNIUM,
  Customer.RHEINMETALL,
  Customer.RHEINMETALLITALY,
  Customer.RHEINMETALLAIRDEFENCE,
  Customer.RME,
  Customer.RMMVO,
  Customer.RWM,
  Customer.BELIMO,
  Customer.PILZ,
  Customer.RADWELL,
  Customer.HAGENUK,
  Customer.AMLAS,
  Customer.VIASTORE,
  Customer.VANDERLANDE,
  Customer.THALES,
  Customer.EBERSPACHER,
  Customer.LEONARDO,
  Customer.PLATH,
  Customer.TAL,
  Customer.ONESUBSEA,
  Customer.DIEHL
];

/** check if current customer is rm/ non-rm  */
export function checkIfRMCustomer(customer: string) {
  if (RM_CLIENTS.includes(customer)) {
    return RM_CLIENT;
  }

  return NON_RM_CLIENT;
  /** bvg, rheinbahn, db */
}
